import { render, staticRenderFns } from "./TgBlockedDialog.vue?vue&type=template&id=4284e9a4"
import script from "./TgBlockedDialog.vue?vue&type=script&lang=js"
export * from "./TgBlockedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports